// extracted by mini-css-extract-plugin
export default {"antiScroll":"styles_antiScroll__3DHyW","moveToLocationWrapper":"styles_moveToLocationWrapper__1o5jB","timeWrapper":"styles_timeWrapper__71V05"};